/**
 * MacroBaby — Language switcher PT-BR / EN.
 * Adiciona links de troca de idioma no header (desktop) e na announcement bar (mobile).
 * Depende de: jQuery (apenas porque é executado dentro de $(document).ready no contexto original)
 */
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const PT_URL = "https://www.br.macrobaby.com/pages/macrobaby-brasil";
        const EN_URL = "https://microbiby.com/";

        const ptImg = "https://cdn.shopify.com/s/files/1/0325/7932/1915/files/pt.webp?v=1677516565";
        const enImg = "https://cdn.shopify.com/s/files/1/0325/7932/1915/files/en.webp?v=1677516565";

        // Em domínio BR, redireciona o logo para a landing BR
        if ("www.br.macrobaby.com" === window.location.host) {
            const logo = document.querySelector(".header__logo-link");
            if (logo) logo.href = "/pages/macrobaby-brasil";
        }

        // Desktop (>= 979px): injeta no header
        if (window.innerWidth >= 979) {
            const headerInner = document.querySelector(".header__inner");
            if (headerInner) {
                const wrapper = document.createElement("div");
                wrapper.className = "idioma";
                wrapper.innerHTML = `
                    <span class="idioma-pt"><a href="${PT_URL}" target="_self" aria-label="Alternar para português"><img src="${ptImg}" width="25" height="25" title="Português" alt="Português"></a></span>
                    <span class="idioma-en"><a href="${EN_URL}" target="_self" aria-label="Switch to English"><img src="${enImg}" width="25" height="25" title="Inglês" alt="Inglês"></a></span>
                `;
                headerInner.appendChild(wrapper);
                setInterval(() => {
                    const pt = document.querySelector(".idioma .idioma-pt a");
                    const en = document.querySelector(".idioma .idioma-en a");
                    if (pt) pt.href = PT_URL;
                    if (en) en.href = "https://microbiby.com";
                }, 100);
            }
        }

        // Mobile (<= 640px): injeta ao lado do carrinho no header
        if (window.innerWidth <= 640) {
            const cartItem = document.querySelector(".header__action-item--cart");
            if (cartItem) {
                cartItem.insertAdjacentHTML("beforebegin", `
                    <div class="idioma">
                        <span class="idioma-pt"><a href="${PT_URL}" target="_self" aria-label="Alternar para português"><img src="${ptImg}" width="25" height="25" title="Português" alt="Português"></a></span>
                        <span class="idioma-en"><a href="${EN_URL}" target="_self" aria-label="Switch to English"><img src="${enImg}" width="25" height="25" title="Inglês" alt="Inglês"></a></span>
                    </div>
                `);
                setInterval(() => {
                    const pt = document.querySelector(".idioma .idioma-pt");
                    const en = document.querySelector(".idioma .idioma-en");
                    if (pt) pt.querySelector("a").href = PT_URL;
                    if (en) en.querySelector("a").href = EN_URL;
                }, 100);
            }

            // Slick slider para .linksCustomers (mobile only — dependeu do bundle Warehouse)
            const links = document.querySelector(".linksCustomers ul");
            if (links) {
                links.classList.add("slick-slider");
                links.setAttribute("data-slick", '{ "infinite": true, "slidesToShow": 3, "slidesToScroll": 3 }');
            }
        }
    });
})();
